import { render, staticRenderFns } from "./ChatView.vue?vue&type=template&id=5d2f58cf&scoped=true"
import script from "./ChatView.vue?vue&type=script&lang=js"
export * from "./ChatView.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/chat.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ChatView.vue?vue&type=style&index=1&id=5d2f58cf&prod&lang=less"
import style2 from "./ChatView.vue?vue&type=style&index=2&id=5d2f58cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2f58cf",
  null
  
)

export default component.exports